module.exports = __webpack_public_path__ + "img/shopGuide_2c_kr_1.aff77d32.jpg";